import { defineBoot } from '#q-app';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { devError } from '@shared/vue/utils/debug';

export default defineBoot(async () => {
  try {
    // Define custom elements for PWA features (camera, etc.)
    await defineCustomElements(window);
  } catch (error) {
    devError('Failed to initialize PWA elements:', error);
  }
});
